<template>
  <router-view />
</template>

<script lang="js">

export default {
  
}

</script>
